export default {
    name: 'ExternalTransfer',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
